// extracted by mini-css-extract-plugin
export default {"cls1":"d3FxvAbmaHv5_YKWC1El","cls2":"sHaAdjnpgGpGk6jT10K0 d3FxvAbmaHv5_YKWC1El"};